import React, {useEffect} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core';
import { BackdropCircular} from 'components';
import { getModmedDuplicatedCustomersApi } from '../../api';
import { useStyles } from './styles';
import NextechDuplicatedCustomerRow from './NextechDuplicatedCustomerRow';


const ModMedDuplicatedCustomersList = ({orderId, selectedCustomerId, setSelectedCustomerId}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    modmedDuplicatedCustomersList,
    loadingModmedDuplicatedCustomers
  } = useSelector((state) => state.store_orders);

  useEffect(() => {
    getModmedDuplicatedCustomersApi({dispatch, orderId});
  }, []);


  return (
    <div>
      <TableContainer>
        <Table aria-label="table" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                Choose Account
              </TableCell>
              <TableCell>
                ModMed UI ID
              </TableCell>
              <TableCell>
                Name
              </TableCell>
              <TableCell>
                Last Name
              </TableCell>
              <TableCell>
                Email
              </TableCell>
              <TableCell>
                Phone
              </TableCell>
              <TableCell>
                Date of Birth
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!modmedDuplicatedCustomersList.length ?
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No matching customers found.
                </TableCell>
              </TableRow>
              :
              <>
                {modmedDuplicatedCustomersList.map((duplicatedCustomer) => {
                  return (
                    <NextechDuplicatedCustomerRow
                      key={duplicatedCustomer.ui_id}
                      duplicatedCustomer={duplicatedCustomer}
                      setNextechCustomerId={setSelectedCustomerId}
                      nextechCustomerId={selectedCustomerId}
                    />
                  );
                })
                }
              </>
            }
          </TableBody>
        </Table>
      </TableContainer>
      <BackdropCircular loading={loadingModmedDuplicatedCustomers} />
    </div>
  );
};

export default ModMedDuplicatedCustomersList;
